module.exports = __webpack_public_path__ + "static/media/farmbook.6d2c6b6d.png";